import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import apiService from '../../services/api-client';
import { ArticleForReclassify } from '../reclassify/interfaces/get-articles-for-reclassify';

export interface ClassifiedProductsState {
  products: ArticleForReclassify[];
  loading: boolean;
  error: string | null;
}

const initialState: ClassifiedProductsState = {
  products: [],
  loading: false,
  error: null,
};

const classifiedProductsSlice = createSlice({
  name: 'classifiedProducts',
  initialState,
  reducers: {
    searchProductsInit: (state) => {
      state.loading = true;
      state.error = null;
    },
    searchProductsSuccess: (state, action: PayloadAction<ArticleForReclassify[]>) => {
      state.loading = false;
      state.products = action.payload;
      state.error = null;
    },
    searchProductsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.products = [];
    },
    clearProducts: (state) => {
      state.products = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  searchProductsInit,
  searchProductsSuccess,
  searchProductsFailure,
  clearProducts,
} = classifiedProductsSlice.actions;

export const searchClassifiedProducts = (companyId: number, query: string) => async (dispatch: any) => {
  console.log('🔍 Searching classified products:', { companyId, query });
  dispatch(searchProductsInit());
  
  try {
    const url = `company/${companyId}/products/classified/lightweight?code=${encodeURIComponent(query)}&description=${encodeURIComponent(query)}`;
    console.log('🌐 API URL:', url);
    
    const response = await apiService().get(url);
    console.log('✅ API Response:', response.data);
    
    // Extraer los productos del array lightweight_product_storages
    const products = response.data?.lightweight_product_storages || [];
    console.log('📦 Extracted products:', products);
    
    dispatch(searchProductsSuccess(products));
  } catch (error: any) {
    console.error('❌ Error searching classified products:', error);
    dispatch(searchProductsFailure(error.message || 'Error al buscar productos clasificados'));
  }
};

export const useClassifiedProductsCore = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: any) => state.classifiedProducts || initialState);
  
  return {
    products: state.products,
    loading: state.loading,
    error: state.error,
    searchProducts: (companyId: number, query: string) => 
      dispatch(searchClassifiedProducts(companyId, query) as any),
    clearProducts: () => dispatch(clearProducts()),
  };
};

export default classifiedProductsSlice.reducer;
